// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Icon } from '@progress/kendo-vue-common';
import { caretAltDownIcon, caretAltRightIcon, caretAltLeftIcon } from '@progress/kendo-svg-icons';
import { getChildrenPosition } from '../utils/misc';
/**
 * @hidden
 */
export var downArrowIcon = caretAltDownIcon;
/**
 * @hidden
 */
export var rightArrowIcon = caretAltRightIcon;
/**
 * @hidden
 */
export var leftArrowIcon = caretAltLeftIcon;
/**
 * @hidden
 */
var MenuItemArrowVue2 = {
  name: 'KendoMenuItemArrow',
  props: {
    itemId: String,
    dir: String,
    verticalMenu: Boolean
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return h("span", {
      "class": "k-menu-expand-arrow",
      "aria-hidden": "true",
      attrs: this.v3 ? undefined : {
        "aria-hidden": "true"
      }
    }, [h(Icon, {
      icon: this.getArrowName(),
      attrs: this.v3 ? undefined : {
        icon: this.getArrowName(),
        role: "presentation"
      },
      role: "presentation"
    })]);
  },
  methods: {
    getArrowName: function getArrowName() {
      var childrenPosition = getChildrenPosition(this.$props.itemId, this.$props.verticalMenu === true, this.$props.dir === 'rtl');
      return childrenPosition === 'downward' ? downArrowIcon : childrenPosition === 'rightward' ? rightArrowIcon : childrenPosition === 'leftward' ? leftArrowIcon : '';
    }
  }
};
/**
 * @hidden
 */
var MenuItemArrow = MenuItemArrowVue2;
export { MenuItemArrow, MenuItemArrowVue2 };